import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ManutencaoPendenteService from "service/gestao/frotas/ManutencaoPendenteService";
import VeiculoService from "service/gestao/frotas/VeiculoService";
import { IdMatchModeOptions, NumberMatchModeOptions, TextMatchModeOptions, filterApplyTemplate, numberFilterTemplate } from "utils/filterUtils";

const manutencaoPendenteService = new ManutencaoPendenteService();
const veiculoService = new VeiculoService();

export default function ManutencaoPendenteListagem() {

    const navigate = useNavigate();

    const [queryParameters] = useSearchParams();
    const [marcas, setMarcas] = useState<any[]>([]);

    useEffect(() => {
        veiculoService.marcasDisponiveis().then(data => setMarcas(data)).catch(erro => console.log(erro));
    }, [])

    const [titulo, setTitulo] = useState<string>('Manutenções Pendentes');

    const defaultFilters: DataTableFilterMeta = {
        identificador: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        marca: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        modelo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        placa: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        quilometragem: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
                }
            ],
            operator: FilterOperator.AND
        },
        horimetro: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const marcaFilterField = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={marcas} filter
            onChange={(e) => options.filterCallback(e.value)} 
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    function gerarManutencao(veiculo: any) {
        navigate(`/manutencaoVeiculo/cadastrar?idVeiculo=${veiculo.id}`);
    }

    return (

        <BaseListagem 
            ordenacao="modelo,ASC" service={manutencaoPendenteService} urlService="/veiculo/manutencaoPendente" 
            showNewButton={false} showEditButton={false} showRemoveButton={false}
            tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="manutencaoPendente" 
        >
            <Column field="identificador" header="Identificador" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="marca.nome" header="Marca" filter filterField="marca" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={marcaFilterField}/>
            <Column field="modelo" header="Modelo" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="placa" header="Placa" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="quilometragem" header="Quilometragem" filter showFilterOperator={false} showAddButton={false} 
                filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate}/>
            <Column field="horimetro" header="Horimetro" filter showFilterOperator={false} showAddButton={false} 
                filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate}/>
            <Column body={(rowData: any) => {
                return <Button 
                    label="Gerar manutenção"
                    onClick={() => { gerarManutencao(rowData) }}
                />
            }} />
        </BaseListagem>
    )
}